<template>
  <div class="home">
    <side-panel />
    <audio-player :episodeId="episodeId"/>
  </div>
</template>

<script>
import AudioPlayer from '@/components/AudioPlayer'
import SidePanel from '@/components/SidePanel'

export default {
  name: 'home',
  components: { AudioPlayer, SidePanel },
  computed: {
    episodeId () {
      return this.$route.params.episodeId
    }
  }
}
</script>

<style scoped lang="scss">

.home {
  height: 100%;
  background-color: $whitish;
}
</style>
